module.exports = __webpack_public_path__ + "static/media/surveyRequest.05d61f0e.svg";